<template>
  <div id="paginaStatisticheScritture">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Statistiche scritture teatro</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <b-row>
              <b-col xl="6" md="6" class="mt-1">
                <ejs-button id="scaricaButton" @click.native="scarica('2025')">Scarica 2025</ejs-button>
              </b-col>
              <b-col xl="6" md="6" class="mt-1">
                <ejs-button id="scaricaButton1" @click.native="scarica('2024')">Scarica 2024</ejs-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  CardPlugin,
  TabsPlugin,
} from "bootstrap-vue";
// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { TextBoxPlugin, NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";


// use bootstrap-vue
Vue.use(ButtonPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(TabsPlugin);
const apiStatisticheUrl = "/demo/api/scrittura/export_statistiche";

export default Vue.extend({
  components: {},
  data() {
    return {
    }
  },

  methods: {
    async scarica (anno) {
        console.log("Scarica");
        const r = await useJwt.post(apiStatisticheUrl, {stagione: anno}, { responseType: "blob"}).then((response) => {
            let fileName = response.headers["content-disposition"].split("filename=")[1];
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            //this.makeToast("success", "Info", "Download  completato con successo!");
      })
    },
  }
});
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/bootstrap.css";
@import "~@syncfusion/ej2-buttons/styles/bootstrap.css";
@import "~@syncfusion/ej2-vue-buttons/styles/bootstrap.css";
</style>
